module.exports = __webpack_public_path__ + "static/kauffman-4a4d653b350a3727b861d387f7824a1b.jpg";